function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Home",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-2",
  fill: "#FFD561",
  x: 0,
  y: 0,
  width: 73,
  height: 73,
  rx: 22
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-4",
  stroke: "#75318C",
  strokeWidth: 2,
  fill: "#FFFFFF",
  x: 24,
  y: 15,
  width: 27,
  height: 45,
  rx: 3
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy",
  fill: "#75318C",
  cx: 38,
  cy: 55,
  r: 2
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#DC7B53",
  x: 45,
  y: 28.342369,
  width: 10,
  height: 5,
  rx: 2.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-6",
  fill: "#DC7B53",
  x: 45,
  y: 34.342369,
  width: 10,
  height: 5,
  rx: 2.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-7",
  fill: "#DC7B53",
  x: 45,
  y: 40.342369,
  width: 10,
  height: 5,
  rx: 2.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-8",
  fill: "#DC7B53",
  x: 45,
  y: 46.342369,
  width: 10,
  height: 5,
  rx: 2.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-5",
  fill: "#75318C",
  x: 25,
  y: 16,
  width: 25,
  height: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.6938776,31.842369 C13.0532526,29.5507023 19.0402317,25.9901554 28.6548151,21.1607283 C30.3253025,20.7925643 31.1605462,21.0568872 31.1605462,21.9536971 C31.1605462,23.2989119 32.1660185,22.8923402 31.6632824,24.1110069 C31.4003599,24.748349 29.552358,26.4011449 26.1192766,29.0693946 C25.4904768,29.5581087 24.4276331,30.3678275 22.9307457,31.4985512 L22.9307457,52.1607283 C22.9307457,53.4858678 22.9307457,54.6770833 22.9307457,55.734375 C22.9307457,57.3203125 18.5578101,53.8538492 16.0947565,52.1607283 C9.2587672,47.46162 7.15481505,35.279869 10.6938776,31.842369 Z",
  id: "Path-2",
  fill: "#DC7B53"
})));

function SvgHandIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "73px",
    height: "73px",
    viewBox: "0 0 73 73",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandIcon);
export default __webpack_public_path__ + "static/media/hand-icon.ddbfd341.svg";
export { ForwardRef as ReactComponent };